import { FC } from 'react';
import { useUnit } from 'effector-react';
import { Tab } from '@mui/material';
import { Wrapper, Tabs } from '@ui/index';
import { $currentTab, changeTab, tabs, $ticket, $isDetailOpen } from '../../models';
import { $isReplaceEmployee, setReplaceEmployee } from '../../models/replace-employee';
import { DetailReplaceEmployee } from '../detail-replace-employee';
import { Ticket } from '../ticket';
import { TicketWorks } from '../ticket-works';
import { RightSduiDetail } from './components/rightSduiDetail';
import { useStyles } from './components/styles';

export const DetailWrap: FC = () => {
  const [isDetailOpen, isReplaceEmployee] = useUnit([$isDetailOpen, $isReplaceEmployee]);
  const closeDetailReplaceEmployee = () => setReplaceEmployee(false);

  const newVersion = localStorage.getItem('ticketsNewVersion') === 'new' ? true : false;

  if (isDetailOpen) return newVersion ? <RightSduiDetail /> : <Detail />;

  if (isReplaceEmployee)
    return <DetailReplaceEmployee closeAction={closeDetailReplaceEmployee} />;

  return null;
};

export const Detail: FC = () => {
  const [currentTab, ticket] = useUnit([$currentTab, $ticket]);
  const classes = useStyles({ external: false });

  const onChange = (_: unknown, tab: string) => changeTab(tab);

  const isNew = !ticket.id;

  return (
    <Wrapper className={classes.wrapper}>
      <Tabs
        options={tabs({})}
        currentTab={currentTab}
        onChange={onChange}
        isNew={isNew}
        tabEl={<Tab />}
        style={{ padding: '0 8px' }}
      />
      {currentTab === 'info' && <Ticket />}
      {currentTab === 'works' && <TicketWorks />}
    </Wrapper>
  );
};
